// extracted by mini-css-extract-plugin
export default {"icon_hover":"src-UI-Icons--icon_hover","icon_gray":"src-UI-Icons--icon_gray"};